import { Controller } from "@hotwired/stimulus";

// Drives the tabs on the consultant `selection_intervenants#mes_missions`
// portfolio page. Pure DOM toggle — no server roundtrip.
export default class extends Controller {
  static targets = ["tab", "pane"];

  switchTab(event) {
    const target = event.currentTarget.dataset.tab;
    if (!target) return;

    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.tab === target);
    });
    this.paneTargets.forEach((pane) => {
      pane.classList.toggle("is-active", pane.dataset.pane === target);
    });
  }
}
